import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";

const Examschedule = () => {
  const [examData, setExamData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [viewItem, setViewItem] = useState(null);
  const [editItem, setEditItem] = useState(null);
  const [sectionList, setSectionList] = useState([]);

  const [formData, setFormData] = useState({
    title: "",
    from_date: "",
    to_date: "",
    result: "",
    section_id: [],
    status: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const examRes = await axios.get(`${process.env.REACT_APP_API}/questions/examschedule`);
        setExamData(examRes.data);
        const sectionRes = await axios.get(`${process.env.REACT_APP_API}/questions/section`);
        setSectionList(sectionRes.data);
      } catch (err) {
        setError("Failed to load data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const getSelectedSections = () => {
    return sectionList
      .filter((sec) => formData.section_id.includes(sec.id))
      .map((sec) => ({ value: sec.id, label: sec.section_name }));
  };

  const handleView = async (id) => {
    const res = await axios.get(`${process.env.REACT_APP_API}/questions/examschedule/${id}`);
    setViewItem(res.data);
  };

  const handleEdit = (item) => {
    let selectedSections = [];
    if (Array.isArray(item.section_id)) {
      selectedSections = item.section_id.map((id) => Number(id));
    } else if (typeof item.section_id === "string" && item.section_id.length > 0) {
      selectedSections = item.section_id.split(",").map((id) => Number(id));
    }

    setFormData({
      title: item.title,
      from_date: item.from_date.split("T")[0],
      to_date: item.to_date.split("T")[0],
      result: item.result ? item.result.split("T")[0] : "",
      section_id: selectedSections,
      status: item.status,
    });
    setEditItem(item);
  };

  const handleUpdate = async () => {
    try {
      const payload = {
        ...formData,
        section_id: formData.section_id.join(","),
      };
      await axios.put(`${process.env.REACT_APP_API}/questions/examschedule/${editItem.id}`, payload);
      alert("Updated successfully");
      setEditItem(null);
      window.location.reload();
    } catch (err) {
      alert("Update failed");
    }
  };

  const handleAdd = async () => {
    try {
      const payload = {
        ...formData,
        section_id: formData.section_id.join(","),
      };
      await axios.post(`${process.env.REACT_APP_API}/questions/examschedule`, payload);
      alert("Added successfully");
      setAddModalOpen(false);
       setFormData ({
            title: "",
    from_date: "",
    to_date: "",
    result: "",
    section_id: [],
    status: "",
       })

      window.location.reload();
    } catch (err) {
      alert("Failed to add");
    }
  };

  const inputStyle = {
    padding: "8px",
    width: "100%",
    border: "1px solid #ccc",
    borderRadius: "4px",
    marginBottom: "10px",
  };

  const modalStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  };

  const modalContentStyle = {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "10px",
    minWidth: "300px",
    maxWidth: "500px",
    display: "flex",
    flexDirection: "column",
  };

  return (
    <div style={{ padding: "20px"  ,overflow:'hidden'}}>
      <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
        <div
          onClick={() => setAddModalOpen(true)}
          style={{
            width: "100px",
            height: "50px",
            backgroundColor: "blueviolet",
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            borderRadius: "5px",
          }}
        >
          ADD +
        </div>
      </div>

      <h2>Exam Schedule List</h2>

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : (
        <table
          border="1"
          cellPadding="10"
          style={{ width: "100%", borderCollapse: "collapse", marginTop: "20px" }}
        >
          <thead>
            <tr>
              <th>S.No</th>
              <th>Exam Title</th>
              <th>From Date</th>
              <th>To Date</th>
              <th>Sections</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {examData.length > 0 ? (
              examData.map((item, index) => {
                let sectionsArray = [];
                if (Array.isArray(item.section_id)) {
                  sectionsArray = item.section_id;
                } else if (typeof item.section_id === "string" && item.section_id.length > 0) {
                  sectionsArray = item.section_id.split(",").map((id) => Number(id));
                }

                const sectionNames = sectionsArray
                  .map((id) => sectionList.find((sec) => sec.id === id)?.section_name)
                  .filter(Boolean)
                  .join(", ");

                return (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.title}</td>
                    <td>{new Date(item.from_date).toLocaleDateString()}</td>
                    <td>{new Date(item.to_date).toLocaleDateString()}</td>
                    <td>{sectionNames || "N/A"}</td>
                    <td>{item.status}</td>
                    <td>
                      <button onClick={() => handleView(item.id)}>View</button>
                      <button onClick={() => handleEdit(item)} style={{ marginLeft: "5px" }}>
                        Edit
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="7" style={{ textAlign: "center" }}>
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}

      {/* Reusable Form Fields */}
      {(editItem || addModalOpen) && (
        <div style={modalStyle}>
          <div style={modalContentStyle}>
            <h3>{editItem ? "Edit Exam" : "Add New Exam"}</h3>

            <label>Title</label>
            <input
              type="text"
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              style={inputStyle}
            />

            <label>From Date</label>
            <input
              type="date"
              value={formData.from_date}
              onChange={(e) => setFormData({ ...formData, from_date: e.target.value })}
              style={inputStyle}
            />

            <label>To Date</label>
            <input
              type="date"
              value={formData.to_date}
              onChange={(e) => setFormData({ ...formData, to_date: e.target.value })}
              style={inputStyle}
            />

            <label>Result Date</label>
            <input
              type="date"
              value={formData.result}
              onChange={(e) => setFormData({ ...formData, result: e.target.value })}
              style={inputStyle}
            />

            <label>Sections</label>
            <Select
              isMulti
              options={sectionList.map((sec) => ({
                value: sec.id,
                label: sec.section_name,
              }))}
              value={getSelectedSections()}
              onChange={(selectedOptions) => {
                const selectedIds = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
                setFormData({ ...formData, section_id: selectedIds });
              }}
            />

            <label>Status</label>
            <select
              value={formData.status}
              onChange={(e) => setFormData({ ...formData, status: e.target.value })}
              style={inputStyle}
            >
              <option value="">Select Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>

            <button
              onClick={editItem ? handleUpdate : handleAdd}
              style={{ ...inputStyle, backgroundColor: "blue", color: "white", cursor: "pointer" }}
            >
              {editItem ? "Update" : "Submit"}
            </button>
            <button
              onClick={() => {
                setEditItem(null);
                setAddModalOpen(false);
              }}
              style={{ ...inputStyle, marginTop: "5px", cursor: "pointer" }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* View Modal */}
   {viewItem && (
  <div style={modalStyle}>
    <div style={modalContentStyle}>
      <h3>View Exam Details</h3>
      <p><strong>Title:</strong> {viewItem.title}</p>
      <p><strong>From Date:</strong> {new Date(viewItem.from_date).toLocaleDateString()}</p>
      <p><strong>To Date:</strong> {new Date(viewItem.to_date).toLocaleDateString()}</p>
      
      <p>
        <strong>Result Date:</strong>{" "}
        {viewItem.result_date
          ? new Date(viewItem.result_date).toLocaleDateString()
          : "No data"}
      </p>

      <p><strong>Sections:</strong> {viewItem.section_id}</p>
      <p><strong>Status:</strong> {viewItem.status}</p>
      <button onClick={() => setViewItem(null)}>Close</button>
    </div>
  </div>
)}

    </div>
  );
};

export default Examschedule;
